export default {
  plannerSap: {
    queryMethod:'查询方式',bySeason:'按年度季节查找',byStyle:'输入单个款号',chooseSeason:'选择季节',optionalStyle:'款号关键词（可选）',
    catalogHint:'查询已同步的 SAP 款式目录，再勾选生成草稿。目录可能不完整；未找到的款号可切换到单款获取。',
    catalogCount:'{system} · 共 {n} 条',catalogEmpty:'目录中暂无符合条件的款号，可使用单款获取。',catalogState:'创建状态',sequenceShort:'生产批次',
    catalogAVAILABLE:'可创建',catalogDRAFT:'已有草稿',catalogSHEET:'已有设计任务',selectPage:'选择本页可创建款号',
    createSelected:'获取并生成所选 {n} 款草稿',openDrafts:'前往建款草稿',reviewDraft:'核对草稿',
    queueWAITING:'等待获取',queueRUNNING:'正在获取',queueDONE:'草稿已生成',queueFAILED:'获取失败',
    stopAfterCurrent:'完成当前款后暂停',queueProgress:'已完成 {done} / {n} 款。',queueDuration:'逐款获取，每款通常约1分钟。',
    queuePaused:'已暂停，成功草稿保留；请核对结果后手动继续。',draftExists:'该款号及单次已有其他企划草稿，请先核对，不重复创建。',
    catalogUnavailable:'SAP同步目录尚未就绪，请使用单款获取并联系管理员检查目录与读取权限。',
    environmentChanged:'现有草稿来自其他SAP环境，请先核对来源，不能按当前环境重复获取。',
    method:'新建方式',manual:'手动录入',fromSap:'从 SAP 获取',manualIntro:'新建空白企划草稿，填写款式资料后发布委托书。',
    intro:'输入 SAP 已有款号，获取资料并生成企划草稿。核对、补充和修改后，再发布委托书。',
    stylePlaceholder:'输入 SAP 款号，自动匹配已授权品牌',sequence:'生产批次',createDraft:'获取并生成草稿',
    firstProductionDefault:'默认查询首次生产，无需填写批次。',chooseProductionBatch:'查询追加生产或其他批次',
    firstProduction:'首次生产（00）',reorderBatch:'第 {n} 次追加生产（{code}）',reorderSelected:'当前查询第 {n} 次追加生产。',
    timedOut:'SAP响应超时，本次未取得资料，不能据此判定款号不存在。请稍后再试或联系接口管理员核查。',
    communicationFailed:'暂未取得SAP有效响应，请稍后再试；这不代表款号不存在。',
    authPaused:'SAP接口认证需要管理员核查，已暂停获取，请勿连续重试。',
    fetchPaused:'SAP数据获取已暂停，请管理员核查接口状态及上次请求结果后恢复。请勿连续重试。',
    connectionNotReady:'SAP查询服务尚未配置完成，请联系管理员。',
    noUsableMaster:'SAP已应答，但未返回该款可用的主数据或颜色尺码。请确认当前SAP环境已同步该款及所选生产批次；未生成草稿。',
    dimensionsMissing:'已取得款式基础资料，但SAP尚未返回完整颜色或尺码。可先保留草稿，补齐范围、数量和其他必填资料后再发布。',
    fetching:'正在依次获取款式主数据和补充资料，通常需要约 1 分钟，请等待。',
    missingHint:'获取年度、季节、售价、入库要求日、担当、品名及颜色尺码数量。性别、销售月和其他缺项需要补充；不会向 SAP 写入数据。',
    prefilled:'已从 SAP 预填',reviewHint:'请核对当前资料并补齐空项，再发布委托书。款号和 SAP 单次保留来源身份，其他企划字段可按权限修改。',
    sourceDetails:'查看 SAP 来源与查询结果',fetchedAt:'获取时间',
    fetchFailed:'未能取得SAP款式资料，请核对款号和当前查询环境。',identityMismatch:'SAP 返回的款号或生产批次与请求不一致，未生成草稿。',
    unconfirmedResult:'接口已应答，但未返回成功的业务状态（XSTAT=S），无法确认取数成功。',
    searchMismatch:'SP0060 返回的款号或单次不一致，已忽略其补充资料，请手动补充品名并核对颜色、尺码与数量。',
    searchUnavailable:'SP0060 补充资料未获取成功。已保留 SP0110 的资料，请补充品名并核对颜色、尺码与数量；查询结果见下方。',
    noDetails:'SAP 未返回可用的颜色或尺码，请确认款号与生产批次，并核查测试环境是否已同步资料。',sheetExists:'该款号已有委托书，请在我的任务中搜索并打开，避免重复建单。',
    requestChanged:'该创建请求已经使用，请重新打开新建窗口。',styleFixed:'SAP 导入的款号不能直接改号，请使用新建入口查询其他款号。',
    invalidResponse:'SAP 返回的数据超出草稿允许范围，请核对接口返回内容。',
    invalidValue:'SAP 字段 {field} 的值不符合填写规则，已留空，请补充。',conflictingValue:'SAP 字段 {field} 存在不同的值，已留空，请核对后填写。',
    invalidQuantity:'部分 SAP 数量为空、非整数或超出范围，相关格子已留空。',quantityMissing:'未提供的颜色×尺码数量保持空白，请填写；0 表示明确未下单。',
    countryExcluded:'仅预填中国（CN）的数量，其他国家或未注明国家的数量未计入。',
    peopleUnmatched:'部分 SAP 工号无法匹配本品牌对应岗位的有效账号，已沿用分工规则或留空，请在负责人页签核对。',
  },
  packStudio: {
    directory:'资料目录',editing:'编辑中',edit:'编辑',basicInfo:'商品基本信息',
    title:'技术资料',subtitle:'图稿、物料与尺寸，在同一份委托书中维护。',
    documentTools:'资料操作',deliveryTools:'文档输出',view:'显示比例',paperWidth:'纸张宽度',
    sourceCount:'来源原件 · {n} 份',scopeHint:'可修改的字段',myModules:'我的录入模块',
    designer:'设计担当',savedScope:'保存状态',finalConfirmation:'最终资料确认',
    sections:{design:'商品与设计',colors:'配色',fabric:'面料',trims:'辅料',sizes:'版型尺寸',quantity:'订货数量',shipping:'包装与运输'},
  },
  workPanel: {
    title:'我的工作',hint:'填写本岗位资料后，一次确认全部录入模块。送审、审批和最终 Tech Pack 确认仍单独操作。',
    noConfirmation:'当前没有属于你的录入完成确认项。可编辑区域已标注，其余资料只读。',
    completeAll:'完成我的全部录入',allDone:'本岗位录入已确认',completed:'本岗位全部录入已确认',
    reopen:'重新打开我的录入',reopened:'本岗位录入已重新打开',reopenConfirm:'重新打开本岗位的录入完成标记，最终 Tech Pack 将需要重新核对。是否继续？',
    incomplete:'以下资料供核对，缺项不影响确认本岗位录入；不适用的内容可留空。确认后仍保留提醒。',locked:'当前无法确认本岗位录入，请核对单据状态及本款担当。',
    readonly:'只读',editableShort:'可编辑',readonlyShort:'只读',
  },
  workEdit: {
    canChange:'可修改：{fields}',separator:'；',
    fabricDetails:'面料编号、名称、部位、颜色与备注',fabricSpecs:'幅宽、单位与克重',usage:'用量',
    trimDetails:'辅料明细、颜色与规格',trimTechnical:'颜色、规格与技术备注',
    patternReferences:'版型模块及参考款信息',baselineSizes:'基准尺寸、测量方法与版型附件',deviations:'尺寸偏差与公差',
    sourceInfo:'品名、年度、季节、性别',supplier:'成衣供应商',sampleInfo:'样衣阶段与样衣尺码',receivingDate:'要求入库日',
  },
  designSourceEdit: {
    hint: '删除原件不会清除已填写的信息或图片。上传正确 PDF 后，请核对差异再预填。',
    parse: '重新解析', replace: '替换并重新解析',
    parseHint: '重新解析现有 PDF，不重复上传原件。缺少的图片会补入，对应图片按原位置更新；表格资料请核对差异。',
    pageRefreshHint: '缺少的图片默认导入，对应的原图片按原分类和顺序更新。手工上传的其他图片保留，可在“图片去向”中选择不上传。',
    updatePage: '更新对应图片，保留分类和顺序',
    ambiguousPage: '有多张同名图片，默认不上传，请核对后选择去向。',
    replaceHint: '请选择正确的 PDF 替换“{name}”。新原件上传成功后才移除旧原件；表格内容保留，新图片请核对去向。',
    singlePdf: '替换时请选择一份不超过 {mb} MB 的 PDF。',
    fileChanged: '原 PDF 已删除或替换，请重新选择当前资料。',
    loadFailed: '未能读取原 PDF，请重试或上传正确的资料。',
  },
  factoryReference:{style:'参考款号',fileChanged:'版型文件已更新，请刷新后重新选择。'},
  factoryPack:{patternLegacy:'旧系统历史',patternDs:'新DS',patternTargetSize:'本款 {size}：{value}',patternLegacyUnsupported:'这份历史尺寸资料存在无法直接引用的格式，请核对原单后填写。',patternSummary:'新增 {added} 个部位，匹配 {matched} 个部位，保留 {preserved} 项已有信息。',patternSizeMissing:'尺码 {sizes} 仍缺少数值，请核对并补充。',patternRefresh:'重新核对',patternClear:'清除参考款号',imagePage:'图页 {n}/{total}',fabricRemark:'面料备注',brandFabricCode:'面料编号',internalCost:'内部成本',patternReference:'从历史款导入版型尺寸',patternSearch:'搜索历史款号或品名',patternApply:'导入所选版型',patternEmpty:'该款没有可预填的版型尺寸',patternReplace:'替换同一部位的已有内容（其他部位保留）',patternReview:'选择要导入的部位，并核对尺寸、公差和测量方法。',cadFiles:'CAD 与版型资料',cadHint:'可上传 PDF、图片、AI、DXF、DWG 或 PLT。CAD 原件供下载使用。',colourInput:'选择辅料颜色，或填写颜色 / 配色字母',specInput:'选择本辅料规格，或直接填写',partSearch:'选择版型部位',methodMissing:'暂无测量方法',referenceNotFound:'参考款号不存在或不在当前品牌范围内',referenceConflict:'版型资料已更新，请重新核对',sourceCode:'辅料编号',patternScale:'有 {n} 个部位，请选择本款需要的部位（最多 200 个）。'},
  packGrid:{tableChanged:'表头、行顺序或页面资料已变化，请重新复制整表后填写并粘贴。',format:'请粘贴完整的矩形区域。',limit:'每次最多粘贴 2,000 个单元格。',range:'粘贴范围超出当前表格，请缩小复制范围。',readOnly:'第 {row} 行、第 {column} 列由其他岗位填写，本次未写入。',invalid:'第 {row} 行、第 {column} 列的内容或格式不符，本次未写入。'},
  packTasks:{more:'展开其余 {n} 项',less:'收起',mine:'我的待办 {n}',collaboration:'协作待办 {n}',missing:'补充{field}',rowMissing:'{kind}第 {row} 行：补充{field}',confirm:'确认：{field}'},
  packStages:{STEP_DONE:'完成设计',DESIGNER_DONE:'完成面辅料设计',PURCHASE_DONE:'完成采购资料',PRODUCTION_REVIEWED:'完成生产核对',TRIM_TECHNICAL_DONE:'确认辅料',BASE_SIZE_DONE:'完成基准尺寸',SIZE_SPEC_DONE:'完成尺寸偏差',USAGE_ENTERED:'完成面料单耗'},
  packEditing:{
    bomColumns:{sequence:'序号',image:'图片',classification:'材料分类',position:'使用部位',name:'材料名称',code:'材料代码',color:'颜色',specification:'规格',usage:'用量/单位',properties:'材料特性',supplier:'供应商名',remark:'备注'},
    washingOptional:'成衣水洗（选填）',washingRequired:'水洗要求',washingHint:'此处填写成衣水洗要求，可留空；面料水洗请填写在面料备注中。',
    usageWithUnit:'用量 / 单位',trimTypeUnnamed:'种类名称待维护',
    fabricSupplier:'面料供应商',materialRecord:'物料资料',patternOwner:'版型引用信息请由本款版师修改',
    fillMethods:'预填测量方法',methodsReference:'参考原版 EADS 上衣模板。请选择适用的方法，仅补充空白内容。',
    quantityOriginal:'原始订货数量',quantitySourceChanged:'上游数量有变化，本页修改已保留。请核对以下差异。',
    quantityComparison:'本页 {local} / 上游 {source}',useSource:'采用上游数量',
    quantityIncomplete:'请补齐数量，未订货的格子填写 0。',quantityRange:'数量须覆盖本款全部颜色与尺码，不能重复。',
    quantityRangeChanged:'上游范围变更涉及本页已修改的数量，请先核对颜色和尺码。',
  },
  designImages: {
    upload:'上传图片',
    addGroup:'新增分类',renameGroup:'更改名称',groupName:'分类名称',removeGroup:'删除分类',
    removeConfirm:'删除空分类“{name}”？',moveTo:'移动到',moveFile:'移动 {name}',earlier:'前移',later:'后移',
    earlierFile:'前移 {name}',laterFile:'后移 {name}',dropHere:'放到此分类',
    nameRequired:'请输入分类名称',nameLength:'分类名称最多 40 个字',duplicateName:'已有同名分类，请更换名称',
    invalidGroup:'分类有重复或缺失，请重新核对',invalidMove:'图片资料已变化，请重新核对分类',
    conflict:'图片分类已更新，请载入最新分类后重试',reload:'载入最新分类',
    reloadConfirm:'载入最新分类会放弃本次尚未保存的分类与排序，原文件会保留。继续吗？',
    retry:'重新保存',saveFailed:'分类未保存，请重试。当前调整已保留。',
  },
  packWorkspace: {designInfo:'设计信息',title:'委托书',upload:'上传资料',uploadPurpose:'资料用途',parsePdf:'PDF 解析 / 设计图片',saveClose:'结束编辑',editSubject:'编辑{subject}',usageCost:'用量与成本',steps:'按环节查看',workspace:'返回委托书',qc:'QC 资料',uploadDone:'完成'},
  fabric: {
    position:'面料位置（POSITION）',sourceClassification:'原稿分类',
    seasonMismatch:'原稿为 {source}，文件名为 {expected}；年度季节待核对。',
    imageKind:'图片用途',imageKinds:{FABRIC:'面料图片',COLOR_CARD:'色卡',STYLE:'应用款式',OTHER:'其他资料'},referenceImages:'备注图片与参考资料',
    title:'面料库',name:'面料名称',image:'图片',search:'开发号、Article、物料号或供应商',create:'新增面料',select:'选择面料',
    developmentCode:'开发号',article:'供应商货号',arsCode:'ARS 编码',sapMaterialNo:'SAP 物料号',vendorNm:'供应商',season:'年度季节',kind:'面料类型',
    composition:'成分原文',widthText:'幅宽原文',weightText:'克重原文',quoteText:'报价原文',finishing:'后整理',colorText:'颜色说明',memo:'备注',
    width:'幅宽',widthUnit:'幅宽单位',weight:'克重',weightUnit:'克重单位',unitPrice:'单价',priceUnit:'报价单位',currency:'币种',
    brandCodes:'适用品牌',isShared:'共用范围',shared:'共用面料',statusLabel:'资料状态',status:{DRAFT:'待完善',ACTIVE:'已确认',INACTIVE:'已停用'},
    verifiedSpecs:'确认规格与报价',source:'来源资料',downloadSource:'下载原件',addImage:'添加图片',sapRecords:'已有物料',
    draftHint:'来源资料待核对；未确认的规格、单位和报价不计入用量与成本。',pendingMaterialNo:'待补物料号',
    replaceSelection:'选择后更新面料信息；已填写的幅宽、用量与单价会保留，请核对是否仍适用。',
    widthUnitRequired:'请填写幅宽单位',weightUnitRequired:'请填写克重单位',quoteUnitRequired:'请填写报价单位与币种',
    brandRequired:'请选择适用品牌',sharedBrandsEmpty:'共用面料无需选择品牌',manageBrandDenied:'只能维护所负责品牌的面料；共用资料由管理员维护',
    editConflict:'面料资料已更新，请重新打开后修改',notFound:'面料不存在或不在当前品牌范围内',sourceNotFound:'暂无来源原件',
    bindingInvalid:'面料来源信息已变化，请重新选择',imageType:'请上传 PNG、JPG 或 WebP 图片',imageRequired:'请选择图片',
    removeImage:'删除图片',removeImageConfirm:'删除这张面料图片？来源原件会保留。',materialEntryHint:'选择面料，核对分类、位置与配色。',
  },
  importReview: {
    fabricClassification:'面料分类',materialCodeType:'代码类型',trimSpecification:'辅料尺码规格',garmentSizes:'适用成衣尺码',garmentColors:'适用成衣颜色',
    source:'原稿',results:'核对预填',images:'图片去向',page:'第 {n} 页',preview:'选择原稿页',
    summary:'补入 {added} 行，匹配 {matched} 行；已有行保留。',ambiguous:'有 {n} 行无法唯一匹配，请核对新增行，避免重复。',
    conflicts:'差异核对',field:'字段',current:'已填写',incoming:'本次识别',keep:'保留已填写',use:'使用识别内容',locked:'由负责同事核对',
    noConflicts:'没有需要替换的已填写内容',baseline:'刷新已有资料',baselineHint:'资料已更新，原稿和识别结果保留，请重新核对差异。',
    applyBaseSize:'预填样衣尺码 {size}',baseSizeKeep:'已填写的样衣尺码请在主信息中修改',baseSizeUnmatched:'原稿样衣尺码 {size} 不在本款尺码范围内',
    undo:'恢复导入前资料',undoDone:'已恢复导入前资料，上传的原件与图片保留',undoHint:'10 分钟内、其他同事尚未修改这些资料时可恢复。',
    sourceNumber:'来源开发号 / Article',complexSpec:'完整规格',sizeApplicability:'适用尺码',actualColor:'辅料颜色',
    pdfSource:'工艺单',fgPage:'FG 资料',stripePage:'条纹 / 配色说明',technicalPage:'工艺说明',otherPage:'设计资料',
    keepRows:'保留已有 {n} 行，仅补缺或写入已确认的差异',noteMaterialIdentity:'开发号与 Article 已保留，SAP 物料号需另行核对。',
    importDone:'预填资料已保存',sampleSize:'原稿样衣尺码',colorDetail:'第 {no} 行辅料颜色包含工艺说明，已保留完整原文，请核对。',
  },
  techPackReview: {
    sourceCode:'原稿代号',
    design:'设计图与工艺资料',fabric:'面料明细',colors:'配色',quantity:'订货数量',trims:'辅料与缝纫线',sizes:'版型尺寸',shipping:'包装与运输',
    section:'资料 {n}/{total}',estimated:'预估',actual:'实际',usage:'用量',usageUnit:'用量单位',widthUnit:'幅宽单位',missingUnit:'单位待确认',
    materialIdentity:'面料编号',articleVendor:'供应商货号 / 供应商',compositionFinishing:'成分 / 后整理',actualColors:'辅料颜色',
    sourceFiles:'来源原件',noData:'暂无资料',notUsed:'不使用',specification:'规格',download:'下载',
    printSections:'按资料连续预览；导出时长表会自动续页。',
    allSizes:'全尺码',thread:'缝纫线',tagging:'吊牌与标签',boxing:'装箱',folding:'折叠与包装',iron:'熨烫',total:'合计',
  },
};
